import { LogoFastship, LogoStorezigzin, LogoZdelivery, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { numberWithCommas } from '@common/utils';

import { OptionData, OptionUiSetting, PdpDeliveryType } from '../../../../type/common.type';

interface Props {
  option: OptionData;
  ui_setting?: OptionUiSetting;
  displayShippingInfo?: boolean;
}

export const ProductInfo = ({ option, ui_setting, displayShippingInfo = true }: Props) => {
  const { type, fee } = option.shipping ?? {};
  const shouldDisplayShippingInfo = displayShippingInfo && option.shipping && type;
  const displayRestockNotificationSelection = ui_setting?.display_style === 'restock_notification_selection';
  const isSoldOut = (!displayRestockNotificationSelection && option.stock_status?.is_sold_out) || false;
  const isRestricted = (!displayRestockNotificationSelection && option.isRestricted) ?? false;
  const isDisabled = isSoldOut || isRestricted;

  return (
    <Container minHeight={shouldDisplayShippingInfo ? '36px' : undefined}>
      <ProductName>
        <Text variant='Body_15_Medium' v3Color={isDisabled ? 'gray300' : 'gray900'}>
          {option.name}
        </Text>
        {isSoldOut && (
          <Text variant='Caption_12_SemiBold' v3Color='gray300' style={{ lineHeight: '18px', whiteSpace: 'pre' }}>
            {' '}
            · 품절
          </Text>
        )}
        {isRestricted && !isSoldOut && option.restrictedLabelText && (
          <Text variant='Caption_12_SemiBold' v3Color='gray300' style={{ lineHeight: '18px', whiteSpace: 'pre' }}>
            {' '}
            · {option.restrictedLabelText}
          </Text>
        )}
      </ProductName>
      {shouldDisplayShippingInfo && (
        <ShippingInfo>
          {type === PdpDeliveryType.GENERAL && (
            <Text variant='Caption_12_Medium' v3Color={isDisabled ? 'gray200' : 'gray500'}>
              일반배송
              {!!fee && (
                <Text variant='Caption_12_Regular' v3Color={isDisabled ? 'gray200' : 'gray400'} as='span'>
                  {' '}
                  (+배송 {numberWithCommas(fee)}원)
                </Text>
              )}
            </Text>
          )}
          <Opacity isDisabled={isDisabled}>
            {type === PdpDeliveryType.FAST && <LogoFastship width={57} height={11} />}
            {type === PdpDeliveryType.ZIGZIN && <LogoZdelivery width={57} height={11} />}
            {type === PdpDeliveryType.VENDOR_FLEX && <LogoStorezigzin width={67} height={11} />}
          </Opacity>
        </ShippingInfo>
      )}
    </Container>
  );
};

const Container = styled.div<{ minHeight?: string }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  ${({ minHeight }) => minHeight && `min-height: ${minHeight}`};
`;

const ProductName = styled.div`
  display: flex;
`;

const ShippingInfo = styled.div`
  margin-top: 4px;
  font-size: 0;
`;

const Opacity = styled.div<{ isDisabled: boolean }>`
  opacity: ${({ isDisabled }) => (isDisabled ? 0.25 : 1)};
`;
